<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>
            검색 조건
          </h4>
        </md-card-header>
        <md-card-actions md-alignment="right">
          <label>
            <input type="checkbox" true-value="Y" false-value="" v-model="query.eMailDeny" /> 수신 거부 제거
          </label>
          <label style="width:20px"></label>
          	미발송 사유
            <select v-model="query.nonpostGb" style="width:100px">
              <option v-for="item in nonPostReceiptTypeList" :key="item.code" :label="item.codeNm" :value="item.code"></option>
            </select>
          <label style="width:20px"></label>
          <md-button class="md-info md-sm"
            @click="searchQuery"
          >
            <md-icon>check</md-icon>
            검 색
          </md-button>
        </md-card-actions>
      </md-card>
      
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>
            검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
          <grid ref="executivesGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @response="response"
          ></grid>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <div>
            <label>
              <input type="checkbox"> 수신 거부 제거
            </label>
            <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
              <md-icon>get_app</md-icon>
              Excel 다운로드
            </md-button>
          </div>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaApi from "@/kuaa/kuaa-api";
import axios from "axios";
import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  components: {
    grid: Grid
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  created() {
    this.initGrid();
    this.queryNonPostReceiptTypes();
  },

  data(){
    return{
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
		
	  nonPostReceiptTypeList: [],
	  
      query: {
        eMailDeny: "",
        eMail2Deny: ""
      },
    }
  },

  methods: {
    /**
     * 검색 실행
     */
    searchQuery() {
      this.doSearch();
    },

    /**
     * 검색조건 초기화
     */
    clearQuery() {
      this.query = {
        eMailDeny: "",
        eMail2Deny: ""
      };
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
    },

    doSearch() {
      this.query.eMail2Deny = this.query.eMailDeny;
      
      this.$refs.executivesGrid.invoke("readData", 1, this.query);
    },
    
    queryNonPostReceiptTypes() {
      kuaaFnc.fncNonPostReceiptTypes(null,res => {
        this.nonPostReceiptTypeList = res.data.data.contents;
      });
    },
    
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_MEMBER_EMAIL_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns'] = [
          {header: '교우번호', name: 'memberNo'},
          {header: '교우명', name: 'memberHnm'},
          {header: '미발송사유', name: 'nonpostGbNm'},
          {header: '이메일 1', name: 'eMail'},
          {header: '이메일 2', name: 'eMail2'},
        ];
    },

    downloadExcel() {
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '이메일목록';
      kuaaApi.requestFileDownload(
          URL_CONST.EMAIL_LIST_EXCEL_DOWNLOAD,
          this.query,
          '이메일목록.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    },

    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"이메일 목록 조회");
      }
    },
  }
}
</script>

<style>

</style>